import {useQuery} from "react-query";
import {Client} from "../../autogenerate/api.generated.clients";


export function useTermsAndConditionsStatus() {
    return useQuery(["termsAndConditions-status"], () => new Client().termsAndConditions_GetTermsAndConditionsStatus());
}
